import styled from "styled-components/macro";
import { theme } from "../../styles/theme";

export const Wrapper = styled.div`
  display: flex;
  max-width: 1360px;
  width: 100%;
  margin: 64px auto;
  justify-content: center;
  & > div {
    padding: 0 80px;
    width: 100%;
    display: flex;
    flex-direction: column;
    @media (max-width: 910px) {
      padding: 0 40px;
    }
    @media (max-width: 820px) {
      padding: 0 20px;
    }
  }
`;

export const Title = styled.div`
  font-size: 40px;
  font-weight: 600;
  margin-bottom: 24px;
  color: ${theme.colors.text};
  align-self: center;
  & span {
    color: ${theme.colors.primary};
  }
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 475px) {
    font-size: 32px;
  }
  @media (max-width: 375px) {
    font-size: 28px;
  }
`;

export const CardWrapper = styled.a`
  max-width: 330px;
  width: 100%;
  height: max-content;
  background: ${theme.colors.bgSecondary};
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  padding: 24px;
  & div {
    font-size: 20px;
    color: ${theme.colors.text};
    margin-bottom: 5px;
  }
  & svg {
    margin-right: 2px;
  }
  & p {
    font-size: 16px;
    color: ${theme.colors.textDimmed};
  }
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  & > a:nth-child(2n) {
    margin: 0 10px;
  }
  @media (max-width: 768px) {
    & > a:nth-child(2n) {
      margin: 24px 0;
    }
    flex-direction: column;
  }
`;
